import { Premise } from '@/api/models/auth/lib/auth.types'
import {
  DesiredDateInterval,
  DesiredDateType,
  PassAutoPayload
} from '@/api/models/requests/lib/requests.types'
import { UploadedFileType } from '@/components/shared/file-uploader'

export type ParkingType = {
  id: string
  label: string
  value: string
}

export type PersonalAccountType = {
  id: string
  name: string
}

export type PassFormSubmitData = {
  description?: string
  properties?: string
  persons?: string[]
  autos?: PassAutoPayload[]
  comment?: string
  files?: UploadedFileType[]
  room?: Premise
  date?: string | null
  personalAccount?: PersonalAccountType
  desiredDateType?: DesiredDateType
  desiredDateInterval?: DesiredDateInterval
}

export enum ConfirmSubmitModalName {
  Person = 'person',
  Auto = 'auto'
}
